<template>
  <div class="block-advantages advantages">
    <div class="container">
      <ul class="advantages__list">
        <li
          v-for="{ icon, name, alt } in advantages"
          :key="alt"
          class="advantages__advantage advantage"
        >
          <a
            @click.prevent="getCall({ type: 'sale', form: 'cars', text: alt })"
            class="advantage__link"
            href="#"
          >
            <img :src="advantageIcon(icon)" :alt="alt" class="advantage__img" />
            <h3 class="advantage__title" v-html="name" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Mixin from "../common/mixin";

export default {
  name: "block-advantages",
  mixins: [Mixin],
  data() {
    return {
      advantages: [
        {
          icon: "agree",
          name: "Гарантия <br> лучшей цены",
          alt: "Гарантия лучшей цены",
        },
        {
          icon: "plus",
          name: "Автомобили <br> в наличии",
          alt: "Автомобили в наличии",
        },
        {
          icon: "time",
          name: "Быстрое <br> оформление",
          alt: "Быстрое оформление",
        },
        {
          icon: "okay",
          name: "Комфортные <br> условия",
          alt: "Комфортные условия",
        },
        {
          icon: "refresh",
          name: "Выгодный обмен <br> по ТРЕЙД-ИН",
          alt: "Выгодный обмен по ТРЕЙД-ИН",
        },
        {
          icon: "shield",
          name: "Официальный <br> дилер",
          alt: "Официальный дилер",
        },
      ],
    };
  },
  computed: {
    advantageIcon: () => (icon) => require(`../images/advantages/${icon}.svg`),
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.advantages {
  padding: 30px 0;

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 38px;
  }

  .advantage {
    &__link {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 11px;
    }

    &__img {
      height: calcFontSize(23, 30, 320, 1920);
    }

    &__title {
      text-align: center;
      color: $white-grey;
      font-size: calcFontSize(10, 14, 320, 1920);
      text-transform: uppercase;
    }
  }
}

@media (max-width: 1200px) {
  .advantages {
    padding: calcFontSize(15, 30, 320, 1920) 0;
    
    &__list {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      row-gap: calcFontSize(27, 34, 320, 1220);
    }
  }
}

@media (max-width: 720px) {
  .advantages {
    &__list {
      grid-template-columns: repeat(2, 1fr);
      padding: unset;
    }
  }
}

@media (max-width: 300px) {
  .advantages {
    &__list {
      grid-template-columns: 1fr;
    }
  }
}
</style>
